import { useNavigate } from "react-router-dom";
import api from "../../../../../utils/axiosInstance";
import { toast } from "../../../../../components/Toast/toast";
import QuotationDetailsCard from "./QuotationDetailsCard";
import QuotationStatusCard from "./QuotationStatusCard";

const DetailsTab = ({ quotationId, quotation, locked, onChange }) => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      await api.delete(`/quotations/${quotationId}`);
      toast.success("Quotation deleted.");
      navigate("/quotations");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to delete quotation");
    }
  };

  return (
    <div className="flex flex-col lg:flex-row gap-5">
      <div className="flex-1">
        <QuotationDetailsCard
          quotation={quotation}
          locked={locked}
          onEdit={() => navigate(`/quotation/edit/${quotationId}`)}
          onDelete={handleDelete}
        />
      </div>

      <div className="lg:w-[500px]">
        <QuotationStatusCard quotation={quotation} onChange={onChange} />
      </div>
    </div>
  );
};

export default DetailsTab;
